import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Initial from './pages/Initial.jsx';
import Products from './pages/Products.jsx';
import Resolution from './pages/Resolution.jsx';
import Exchange from './pages/Exchange.jsx';
import Coupon from './pages/Coupon.jsx';
import Refund from './pages/Refund.jsx';
import Post from './pages/Post.jsx';
import { OccurrenceProvider } from './context/OccurrenceContext.jsx';
import './App.css';
import { applyBrandTheme } from './utils/brandTheme.js';

// Usa a cor/raio/fonte do tema da loja (passados pelo bloco do tema).
applyBrandTheme();


function App() {
  return (
    <OccurrenceProvider>
      <Router>
        <Routes>
          <Route exact path='/:shop' element={<Initial />} />
          <Route path='/:shop/products/:name/:email' element={<Products />} />
          <Route path='/:shop/resolution/:name/:email' element={<Resolution />} />
          <Route path='/:shop/exchange/:name/:email' element={<Exchange />} />
          <Route path='/:shop/coupon/:name/:email?' element={<Coupon />} />
          <Route path='/:shop/refund/:name/:email?' element={<Refund />} />
          <Route path='/:shop/post/:name/:email?' element={<Post />} />
          </Routes>
        </Router>
    </OccurrenceProvider>
  );
}

export default App;
